// @flow
// Utils
import traverse from 'fc-utils/traverse'

// Constants
import { TREE, BRANCH } from 'fc-model-fertilizers'

export default traverse([TREE, BRANCH])
